import { useEffect, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import _ from "lodash";
import { label } from "../../../../config";

/**
 * common dropdown in project sidebar for dynamic variables in admin console
 * @param {*} param
 * @author {Prachi Jain}
 */

const CompanyFeatureSetting = ({ keyName, title, handleChange, IsEnabled, dropdownData, dropdownValue }) => {
  const [finalValue, setFinalValue] = useState({});

  /**
   * set final value as select if we dont have any value
   */
  useEffect(() => {
    setFinalValue(dropdownValue || { Name: label.SELECT });
  }, [dropdownData, dropdownValue]);

  const handleOnChange = (event) => {
    setFinalValue(event.value);
    handleChange(event);
  };
  return (
    <>
      <label htmlFor={keyName} className='col-6'>
        {title}
      </label>
      <DropDownList id={keyName} name={_.camelCase(keyName)} data={dropdownData} value={finalValue} onChange={handleOnChange} textField='Name' dataItemKey='EntityId' disabled={!IsEnabled} />
    </>
  );
};

export default CompanyFeatureSetting;
